import React from 'react'
import ChartContainer from '../../components/analytics/ChartContainer'
import { BarChart, AreaChart, Area, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import CustomTooltip from '../../components/analytics/CustomTooltip';

const AverageReviewTimeChart = ({
    isLoading,
    errorMessage,
    isValueZero,
    data,
    chartDescription
}) => {

    const CustomMonthTick = ({ x, y, payload, index }) => {
        const week = payload.value;
        const current = data.find((d) => d.week === week);
        const prev = index > 0 ? data[index - 1] : null;
        const displayMonth = !prev || prev.month !== current?.month ? current?.month : "";
        console.log("Current: ", current, "Prev: ", prev, "Display Month: ", displayMonth);

        return (
            <g transform={`translate(${x},${y + 10})`}>
                <text x={0} y={0} dy={10} textAnchor="middle" fill="#666" fontSize={12}>
                    {displayMonth}
                </text>
            </g>
        );
    };

    return (
        <ChartContainer
            title="Average Application Review Time"
            isLoading={isLoading}
            errorMessage={errorMessage}
            isValueZero={isValueZero}
            chartDescription={chartDescription}
        >
            <AreaChart
                width={460}
                height={300}
                data={data}
                margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
            >
                <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
                        <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
                    </linearGradient>
                </defs>

                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="week" tick={<CustomMonthTick />} interval={0} />
                <YAxis dataKey="averageHours" tick={{ fontSize: 12 }} />
                <Tooltip
                    content={
                        <CustomTooltip
                            labelFormatter={(label) => `Week: ${label}`}
                            valueFormatter={(value) => `${value} hours`}
                        />
                    }
                />

                <Area
                    type="monotone"
                    dataKey="averageHours"
                    stroke="#8884d8"
                    fillOpacity={1}
                    fill="url(#colorUv)" />
                {/* <Area type="monotone" dataKey="pv" stroke="#82ca9d" fillOpacity={1} fill="url(#colorPv)" /> */}
            </AreaChart>
        </ChartContainer>
    )
}

export default AverageReviewTimeChart